import UploadError from './UploadError'

export default UploadError
